export const HD_HOST_NAME = 'https://www.homedepot.com';

export const categories = {
  FENCE: 'BRIO_INAISLE_SFI_FENC',
  SOLAR: 'BRIO_INAISLE_SFI_SOLARPWR',
  SHOWER_DOOR: 'BRIO_INAISLE_SFI_SDOOR',
  KITCHEN_CABINET: 'BRIO_INAISLE_SFI_CABINETS',
  CABINET_MAKEOVER: 'BRIO_INAISLE_SFI_CABR',
  CLOSET: 'BRIO_INAISLE_SFI_CLOS_ORG',
  GARAGE_ORG: 'BRIO_INAISLE_SFI_GAR_ORG',
  WINDOW: 'BRIO_INAISLE_SFI_WIND',
  KIRSCH_WINDOWS: 'kirsch-custom-window-treatments/51e8e1b61',
  WATER_TREATMENT: 'water-treatment/879700ce6',
  HVAC: 'BRIO_INAISLE_SFI_HVAC',
  BATHLINERS: 'BRIO_INAISLE_SFI_BATHLINERS',
  GENERATOR: 'BRIO_INAISLE_SFI_GENE',
  INTERIOR_SHUTTER: 'BRIO_INAISLE_SFI_SHUT'
};

export const leadGenFormTitle = {
  BRIO_INAISLE_SFI_BLND: 'Blinds Installation',
  BRIO_INAISLE_SFI_CABR: 'Cabinet Makeover',
  BRIO_INAISLE_SFI_CABINETS: 'Kitchen Cabinet Installation',
  BRIO_INAISLE_SFI_CLOS_ORG: 'Closet Installation',
  BRIO_INAISLE_SFI_FENC: 'Fence Installation',
  BRIO_INAISLE_SFI_SOLARPWR: 'Solar Panel Installation',
  BRIO_INAISLE_SFI_SDOOR: 'Shower Door Installation',
  BRIO_INAISLE_SFI_GAR_ORG: 'Garage Storage Installation',
  BRIO_INAISLE_SFI_WIND: 'Window Installation',
  BRIO_INAISLE_SFI_HVAC: 'HVAC Installation & Replacement',
  BRIO_INAISLE_SFI_BATHLINERS: 'Tub to Shower Conversion',
  BRIO_INAISLE_SFI_GENE: 'Generator Installation',
  BRIO_INAISLE_SFI_SHUT: 'Plantation Shutter Installation',
  'kirsch-custom-window-treatments/51e8e1b61': 'Kirsch Custom Window Treatments',
  'water-treatment/879700ce6': 'Water Treatment Services'
};

export const dualPathIdentifiers = {
  BRIO_INAISLE_SFI_CABINETS: 'KITCHEN_CABINETS',
  BRIO_INAISLE_SFI_BATHLINERS: 'BATHLINERS',
  BRIO_INAISLE_SFI_SDOOR: 'SHOWER_DOOR'
};